var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-cards"
  }, [_c('div', {
    staticClass: "d-md-none"
  }, [_c('v-img', {
    staticClass: "link-card",
    attrs: {
      "src": "/images/event/clover/mobile/link-card-1.png"
    }
  }, [_c('router-link', {
    staticClass: "link-card__button",
    attrs: {
      "to": "/gshop/brand",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("나누리 캐시 충전")])])], 1), _c('v-img', {
    staticClass: "link-card",
    attrs: {
      "src": "/images/event/clover/mobile/link-card-2.png"
    }
  }, [_c('a', {
    staticClass: "link-card__button",
    attrs: {
      "href": "https://pf.kakao.com/_xoQFxjxb",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("대한문고 친구 추가")])])])], 1), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-img', {
    staticClass: "link-card",
    attrs: {
      "src": "/images/event/clover/link-card-1.png"
    }
  }, [_c('router-link', {
    staticClass: "link-card__button",
    attrs: {
      "to": "/gshop/brand",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("나누리 캐시 충전")])])], 1), _c('v-img', {
    staticClass: "link-card",
    attrs: {
      "src": "/images/event/clover/link-card-2.png"
    }
  }, [_c('a', {
    staticClass: "link-card__button",
    attrs: {
      "href": "https://pf.kakao.com/_xoQFxjxb",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("대한문고 친구 추가")])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }